<template>
  <PForm
    ref="pForm"
    :show-header="false"
    :primary-cta="formState.edit ? updateButton : {}"
    :secondary-cta="{}"
    :body-class="formState.edit ? 'q-px-2x-md q-pt-xl' : ''"
    @submit.prevent="onSubmit"
  >
    <div class="col-12 q-mt-xl">
      <span class="text-md text-weight-medium text-neutral"> PO Setting </span>
      <q-separator class="q-mb-sm" />
    </div>

    <div class="flex q-col-gutter-lg">
      <div>
        <PField v-model="poApplicable" label="Customer will share PO?">
          <template #control>
            <POptionGroup
              v-model="poApplicable"
              color="primary-100"
              size="md"
              keep-color
              :options="poApplicableOptions"
            ></POptionGroup>
          </template>
        </PField>
      </div>
      <div class="q-ml-xxs">
        <PField v-model="poFileApplicable" label="Proof of document required?">
          <template #control>
            <POptionGroup
              v-model="poFileApplicable"
              color="primary-100"
              size="md"
              keep-color
              :disable="poApplicable"
              :options="poFileApplicableOptions"
            ></POptionGroup>
          </template>
        </PField>
      </div>
    </div>
  </PForm>
</template>

<script setup>
import { useQuasar } from "quasar";

import PConfirmDialog from "src/components/PConfirmDialog.vue";
import poSettingFormModel from "../models/poSettingForm";

const $q = useQuasar();

const pForm = ref(null);

const { formState, user } = storeToRefs(useUserStore());
const { putUser, toggleUserForm } = useUserStore();

const computedEntity = computed(() => unref(user)?.othersInfo?.poSetting);

const { formData, submitForm, isLoading } = useForm({
  formModel: poSettingFormModel(),
  entity: computedEntity,
  formRef: pForm,
  isForm: formState,
  put: putUser,
  toggleForm: toggleUserForm,
});

const isAgentRole = computed(() => {
  return ["agent"].includes(unref(formData).role);
});

const poApplicable = computed({
  get() {
    return Boolean(unref(user)?.othersInfo?.poSetting?.po_applicable);
  },
  set(value) {
    unref(user).othersInfo.poSetting.po_applicable = Boolean(value);

    unref(user).othersInfo.poSetting.po_file_applicable = value;

    unref(formData).po_file_applicable = value;

    unref(formData).po_applicable = Boolean(value);
  },
});

const poFileApplicable = computed({
  get() {
    return Boolean(unref(user)?.othersInfo?.poSetting?.po_file_applicable);
  },
  set(value) {
    unref(user).othersInfo.poSetting.po_file_applicable = Boolean(value);

    unref(formData).po_file_applicable = Boolean(value);
  },
});
const poApplicableOptions = ref([
  { label: "No", value: false },
  {
    label: "Yes",
    value: true,
    labelInfo: "Future POs will require a PO Number and PO File.",
  },
]);

const poFileApplicableOptions = ref([
  { label: "No", value: false },
  {
    label: "Yes",
    value: true,
  },
]);

const updateButton = computed(() => {
  return {
    loading: unref(isLoading),
    label: "Update",
    type: "update",
  };
});

const onSubmit = async () => {
  $q.dialog({
    component: PConfirmDialog,
    componentProps: {
      text: `Are you sure you want to edit these details ?`,
      isFooterVisible: true,
      submittable: true,
      cancellable: true,
      closable: true,
      onConfirm: async () => await submitForm(unref(isAgentRole)),
    },
  });
};
</script>
